const DIGITAL_MARKETING_LISTVIEW_REDIRECTS = {
  '/find/digital-marketing-agencies/tweed-heads-nsw':
    'https://business.localsearch.com.au/digital-marketing/tweed-coast/',
  '/find/digital-marketing-agencies/gold-coast-qld':
    'https://business.localsearch.com.au/digital-marketing/gold-coast/',
  '/find/digital-marketing-agencies/alice-springs-nt':
    'https://business.localsearch.com.au/digital-marketing/alice-springs/',
  '/find/digital-marketing-agencies/darwin-nt':
    'https://business.localsearch.com.au/digital-marketing/darwin/',
  '/find/digital-marketing-agencies/townsville-qld':
    'https://business.localsearch.com.au/digital-marketing/townsville/',
  '/find/digital-marketing-agencies/mackay-qld':
    'https://business.localsearch.com.au/digital-marketing/mackay/',
  '/find/digital-marketing-agencies/northern-rivers-nsw':
    'https://business.localsearch.com.au/digital-marketing/northern-rivers/',
  '/find/digital-marketing-agencies/whitsundays-qld':
    'https://business.localsearch.com.au/digital-marketing/whitsundays/',
  '/find/digital-marketing-agencies/cairns-qld':
    'https://business.localsearch.com.au/digital-marketing/cairns/',
  '/find/digital-marketing-agencies/canberra-act':
    'https://business.localsearch.com.au/digital-marketing/canberra/',
  '/find/digital-marketing-agencies/coffs-harbour-nsw':
    'https://business.localsearch.com.au/digital-marketing/coffs-harbour/',
  '/find/digital-marketing-agencies/rockhampton-qld':
    'https://business.localsearch.com.au/digital-marketing/rockhampton/',
  '/find/digital-marketing-agencies/gympie-qld':
    'https://business.localsearch.com.au/digital-marketing/gympie/',
  '/find/digital-marketing-agencies/albury-nsw':
    'https://business.localsearch.com.au/digital-marketing/albury-wodonga/',
};

module.exports = DIGITAL_MARKETING_LISTVIEW_REDIRECTS;
